<template>
   
    <div   >
      <div 
        style="margin-right: 5px; display:inline-block"
        v-for="(letter, idx) in letters"
        :key="idx"
        class="link"
        @click="emitLetter(letter)"
      >
        {{ letter }}
      </div>
      <div style="display:inline-block" @click="emitLetter('')" class="link">{{ S0007 }}</div>
    </div>
   
</template>

<script>
import { getSTRING } from '@/js/utils';

export default {
  name: "AlphabeticalComponent",
  props: [ 'lang'],
  emits: { search: null },
  data() {
    return {
      letters: null,
      S0007: ''
    };
  },
  mounted() {
    const alpha = Array.from(Array(26)).map((e, i) => i + 65);
    this.letters = alpha.map((x) => String.fromCharCode(x));
    this.S0007 = getSTRING(this.lang , "S0007" , "LISTA COMPLETA" )
  },
  methods: {
    emitLetter(letter) {
        this.$emit("search" , letter);
    }
  }
};
</script>

<style>
</style>